export const TOGGLE_DISTRIBUTION_DRAWER = "TOGGLE_DISTRIBUTION_DRAWER";
